<template>
  <div>
    <div class="header">
      <div class="header__item">
        <CustomSelect
          :options="this.residencyOptions"
          label="ЖК"
          optionValueKey="resident_id"
          optionLabelKey="resident_name"
          :value="this.filters.resident_id"
          @change="(value) => onChange('resident_id', value)"
          :required="true"
        />
      </div>
      <div class="header__item">
        <CustomSelect
          :options="this.entranceOptions"
          label="Подъезд"
          optionValueKey="entrance"
          optionLabelKey="entrance"
          :value="this.filters.entrance"
          @change="(value) => onChange('entrance', value)"
        />
      </div>
      <div class="header__item">
        <CustomSelect
          :options="purposeTypeOptions"
          label="Назначение"
          optionValueKey="room_purpose_id"
          optionLabelKey="room_purpose_name"
          :value="this.filters.room_purpose_id"
          @change="(value) => onChange('room_purpose_id', value)"
          fullWidth
        />
      </div>
      <q-btn
        type="submit"
        @click="this.getData"
        :loading="this.isFetching"
        :disable="this.deleting"
        size="md"
        no-wrap
        color="primary"
      >
        <q-icon name="search" />
        Поиск
      </q-btn>
    </div>
    <CustomTable
      title="Смета по черновой"
      :rowsData="this.rowsData"
      :columns="this.shellEstimatesColumns"
      :loading="isFetching"
      :show-search="true"
      :custom-body="true"
    >
      <template #customBody="props">
        <q-tr>
          <custom-table-cell align="center" vertical-align="center">
            <span>{{ props.row.entrance }}</span>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <span>{{ props.row.floor }}</span>
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <span>{{ props.row.room_purpose_name }}</span>
          </custom-table-cell>
          <custom-table-cell align="center" vertical-align="center">
            <span>{{ props.row.purpose_type }}</span>
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <span>{{ props.row.room_name }}</span>
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <span>{{ props.row.floor_param_type_name }}</span>
          </custom-table-cell>
          <custom-table-cell align="left" vertical-align="center">
            <span>{{ props.row.volume }}</span>
          </custom-table-cell>
        </q-tr>
      </template>
    </CustomTable>
  </div>
</template>

<script>
import CheckOrClose from "@/components/common/CheckOrClose";
import CustomIcon from "@/components/common/CustomIcon";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import {
  getRoomPurposeOptions,
  getShellEstimates,
  shellEstimatesColumns
} from "@/views/ShellEstimates/services";
import { getResidentialEntrances, getResidentialSettingsList } from "../BuildingSettings/services";

export default {
  name: "ShellEstimates",
  components: {
    CustomInput,
    CustomIcon,
    CustomTableCell,
    CustomTable,
    CustomSelect,
    CheckOrClose,
  },
  data() {
    return {
      purposeTypeOptions: [],
      residencyOptions: [],
      entranceOptions: [],
      rowsData: [],
      shellEstimatesColumns,
      filters: {
        resident_id: "",
        entrance: "",
        room_purpose_id: null,
      },
      isFetching: false,
      deleteLoading: {},
      deleting: false,
    };
  },
  mounted() {
    this.getResidencyOptions();
    this.getRoomPurposeOptions();
  },
  methods: {
    async getResidencyOptions() {
      const res = await getResidentialSettingsList();
      this.residencyOptions = res || [];
    },
    async getRoomPurposeOptions() {
      const res = await getRoomPurposeOptions();
      this.purposeTypeOptions = res || [];
    },
    async getEntranceOptions(resident_id) {
      const res = await getResidentialEntrances(resident_id);
      this.entranceOptions = res || [];
    },
    async onChange(key, value) {
      this.filters[key] = value;
      if (key === "resident_id" && value !== "") {
        await this.getEntranceOptions(this.filters.resident_id);
        this.filters.entrance = "";
      }
    },
    async getData() {
      this.isFetching = true;
      const res = await getShellEstimates(this.filters);
      this.isFetching = false;
      if (!res) return;
      this.rowsData = res;
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: flex-end;
  gap: 15px;
  flex-wrap: wrap;
  margin-bottom: 25px;
  &__item {
    width: 200px;
  }
  @media (max-width: 400px) {
    &__item {
      width: 100%;
    }
  }
}
</style>
